<div class="popup">
  <div class="close-btn mb-2">
    <img src="assets/images/cancel.svg" alt="cancel" [mat-dialog-close]="true" />
  </div>

  <div class="viewer">
    <pre>{{ responseData | json }}</pre>
  </div>
</div>
